import * as THREE from "three";
import { MeshStandardMaterial } from "three";
import { Vector3 } from "three";
import { ArrowHelper } from "three";
import { AxesHelper } from "three";
import { WebGLRenderer } from "three";
// レンダラーの生成
export default class BaseWebGL {
  constructor(frameEl) {
    this.frame = frameEl;
    this.scene = new THREE.Scene();
    this.camera = new THREE.PerspectiveCamera(45, frameEl.clientWidth / frameEl.clientHeight, 0.1, 10000);
    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    // const renderer = new THREE.CanvasRenderer();
    this.directionalLight = new THREE.DirectionalLight(0xffffff, 1.0);
    // //レンダラーの初期化
    this.initRenderer(frameEl)
    // //カメラの初期化
    this.initCamera(frameEl)
    // initLight();
    // //オブジェクトの初期化
    // this.initObject()
  }
  initRenderer(frameEl)  {
    // レンダラーのサイズ設定
    const dpr = window.devicePixelRatio || 1;
    this.renderer.setPixelRatio(dpr);
    this.renderer.setSize(frameEl.clientWidth, frameEl.clientHeight)
    // フレームELにレンダラーのDOMを追加(canvas)
    // this.renderer.shadowMap.enabled = true;
    this.renderer.setClearColor(0x000000, 1);
    frameEl.appendChild(this.renderer.domElement)
  }
  draw(){
    this.renderer.clear()
    this.renderer.render(this.scene, this.camera)
  }
  initAxes() {
    const axes = new AxesHelper(20)
    this.scene.add(axes);
    axes.position.set(0, 0, 0)
    this.scene.add(axes);
  }
  initGrid() {
    const size = 20;
    const divisions = 5;
    const gridHelper = new THREE.GridHelper(size, divisions);
    gridHelper.position.set(0,0,0)
    this.scene.add(gridHelper);
  }
  initObject(){
    // const arrow = new ArrowHelper(new Vector3(1,0,1).normalize(),new Vector3(0,0,0),70,0xff0000)
    // this.scene.add( arrow );
    // arrow.position.set(1,0,0)
    const gsize = 8;
    const geometry = new THREE.BoxGeometry(gsize, gsize, gsize)
    const material = new THREE.MeshStandardMaterial({ color: 0x22dd22 })
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(0, gsize / 2, 0)
    this.scene.add(mesh);
    // for (let i = 0; i < 20; i++) {
    //     const geometry = new THREE.BoxGeometry(gsize, gsize, gsize)
    //     const material = new THREE.MeshStandardMaterial({ color: 0x22dd22, roughness: 0.1,
    //         metalness: 0.2, })
    //     // material.transparent = true
    //     // material.opacity = .5
    //     const mesh = new THREE.Mesh(geometry, material);
    //     // geometry.position.x = Math.round((Math.random() - 0.5) * 19) * 50 + 25;
    //     // geometry.position.y = 25;
    //     // mesh.position.set(getRandomArbitrary(-2,10), gsize/2, -6)
    //     mesh.position.set(getRandomArbitrary(-2,i+7), gsize/2, getRandomArbitrary(-6,i+7))
    //     this.scene.add(mesh);
    // }
  }

  initCamera(frameEl) {
    // camera.position.set(x, y, z);
    camera.position.set(0, 0, 0);
    // this.camera.position.set(20, 8, 20);
    // this.camera.lookAt(new THREE.Vector3(0, 0, 0));
  }
  initLight() {
    this.directionalLight.position.set(5, 10, 5)
    this.directionalLight.castShadow = true;
    this.scene.add(this.directionalLight);
  }
  tick() {
    this.camera.position.x = 20 * Math.sin(Date.now() / 8000);
    this.camera.position.y = 18;
    this.camera.position.z = 20 * Math.cos(Date.now() / 8000);
    // レンダリング
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));
    this.renderer.render(this.scene, this.camera);
    requestAnimationFrame(this.tick);
  }
  // util
  getRandomArbitrary = (min, max) => {
    return Math.random() * (max - min) + min;
  }
  calcBounceValue(bottomPosition, initialSpeed, timeCounter, acceleration) {
    return (bottomPosition) + (initialSpeed) * timeCounter - 0.5 * acceleration * timeCounter * timeCounter;
  }
  hexToVec3 = (hex) => {
    const col = new THREE.Color(hex);
    return new THREE.Vector3(col.r, col.g, col.b);
  }
  isSmartPhone = () => {
  // デバイス幅が640px以下の場合にスマホと判定する
  if (window.matchMedia && window.matchMedia('(max-device-width: 768px)').matches) {
    return true;
  } else {
    return false;
  }
}
  scroll() {
      inertialScroll +=
        ((document.documentElement.scrollTop || document.body.scrollTop) 
        - inertialScroll) * 0.08;
      // 慣性スクロールでのパーセント
      inertialScrollPercent = (
        inertialScroll / (
            (document.documentElement.scrollHeight || document.body.scrollHeight) 
            - document.documentElement.clientHeight
        ) * 100).toFixed(2);
      
     // 検証用の通常のパーセント
     const scroll = (
       (document.documentElement.scrollTop || document.body.scrollTop) 
       / ((document.documentElement.scrollHeight
         || document.body.scrollHeight) 
         - document.documentElement.clientHeight)
       ) * 100;
    //  document.getElementById('percent').innerText = inertialScrollPercent;
    //  document.getElementById('scroll').innerText = Number(scroll).toFixed(2);
  }
}
// const initThree = (frameEl) => {




//   // //レンダラーの初期化
//   initRenderer(frameEl)
//   // //カメラの初期化
//   initCamera(frameEl)
//   // initLight();
//   // //オブジェクトの初期化
//   initObject()
//   // //描画
//   draw()
//   tick()
// }




